/**
 * generalOutline.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 개요 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 개요 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import img1 from 'assets/Desktop/images/parcelOut/summary_planimages_84a.png';
import img2 from 'assets/Desktop/images/parcelOut/summary_planimages_84b.png';
import img3 from 'assets/Desktop/images/parcelOut/summary_planimages_109.png';
import img4 from 'assets/Desktop/images/parcelOut/summary_planimages_84d.png';
import img5 from 'assets/Desktop/images/parcelOut/summary_planimages_84e.png';

import bgPremium1 from 'assets/Desktop/images/parcelOut/premium_01.jpg';
import bgPremium2 from 'assets/Desktop/images/parcelOut/premium_02.jpg';
import bgPremium3 from 'assets/Desktop/images/parcelOut/premium_03.jpg';
import bgPremium4 from 'assets/Desktop/images/parcelOut/premium_04.jpg';

import bgPremiumMo1 from 'assets/Mobile/images/ParcelOut/mo_premium_01.jpg';
import bgPremiumMo2 from 'assets/Mobile/images/ParcelOut/mo_premium_02.jpg';
import bgPremiumMo3 from 'assets/Mobile/images/ParcelOut/mo_premium_03.jpg';
import bgPremiumMo4 from 'assets/Mobile/images/ParcelOut/mo_premium_04.jpg';


/**
 * 개요 탭의 분양일정 메뉴에 사용되는 데이터입니다.
 */
export const dataCalender = [
  { date: '2022.10.11', detail : '특별공급'},
  { date: '10.12', detail : '1순위 청약'},
  { date: '10.13', detail : '2순위 청약'},
  { date: '10.19', detail : '당첨자 발표'},
  { date: '10.31 ~ 11.2', detail : '정당 계약'}
];

/**
 * @deprecated
 * 개요의 프리미엄 메뉴에 사용되는 데이터입니다.
 * ※ 현재는 사용하지 않습니다.
 */
export const dataPremium = [
  {
    img: bgPremium1,
    moImg: bgPremiumMo1,
    subtit: 'PREMIUM 1',
    tit: '합리적 조건으로 만나는\n수도권 대단지 브랜드 아파트'
  },
  {
    img: bgPremium2,
    moImg: bgPremiumMo2,
    subtit: 'PREMIUM 2',
    tit: '교육, 편의, 자연, 직장까지\n모두 갖춘 올인원 생활 환경'
  },
  {
    img: bgPremium3,
    moImg: bgPremiumMo3,
    subtit: 'PREMIUM 3',
    tit: '서울을 앞마당처럼 누리는\n사통팔달 쾌속 교통망'
  },
  {
    img: bgPremium4,
    moImg: bgPremiumMo4,
    subtit: 'PREMIUM 4',
    tit: 'e편한세상이 선사하는\n프리미엄 라이프 스타일'
  }
];

/**
 * 평방미터를 평형으로 계산하기 위한 기본 고정 값입니다.
 * 평방미터 * CAL_FEET 하여 처리하며 Math.floor(평방미터(공급면적) * CAL_FEET)를 하여 소수점을 없앱니다.
 */
const CAL_FEET: number = 0.3025;

/**
 * 개요의 세대정보 메뉴에 사용되는 데이터입니다.
 */
export const dataSlide = [
  {
    img: img1,
    title: '84㎡A형',
    titleSwitchActive: `${Math.floor(111.0626 * CAL_FEET)}평A형`,
    subTitle: '30',
    subTitle02: '123',
    total: '428',
    detail: '우수한 개방감과 여유로운 공간구성, 주방 원스톱 세탁실 등을 \n갖춰 생활의 편리함을 극대화한 판상형 구조'
  },
  {
    img: img2,
    title: '84㎡B형',
    titleSwitchActive: `${Math.floor(112.1926 * CAL_FEET)}평B형`,
    subTitle: '5',
    subTitle02: '22',
    total: '57',
    detail: '더 넓어진 개방감으로 채광과 통풍이 우수하고, \n넉넉한 주방공간과 드레스룸이 갖춰진 코너 판상형 구조'
  },
  {
    img: img3,
    title: '109㎡형',
    titleSwitchActive: `${Math.floor(141.9951 * CAL_FEET)}평형`,
    subTitle: '1',
    subTitle02: '8',
    total: '60',
    detail: '넉넉한 거실과 주방, 알파공간을 갖추어 공간은 보다 더 여유로우며,\n 맞통풍 평면설계를 통해 채광과 환기를 극대화한 판상형 구조'
  }
];

/**
 * 개요의 세대정보 메뉴에서 계를 나타내는데 사용되는 데이터입니다.
 */
export const dataSlideResult = {
  title: '계',
  subTitle: '38',
  subTitle02: '169',
  total: '545'
};
